export const RouteNames = {
  ACTIVE_LOANS: 'loan-active',
  CLOSED_LOANS: 'loan-closed',
  CONTRACT_SCHEDULE: 'contract-schedule',
  REVOLVING_LOAN: 'revolving-loan',
  LOAN_CONTRACT_DETAILS: 'loan-contract-details',
  APPLY_THROUGH_PARTNER: 'apply-through-partner'
}
